<template>
    <console-layout width="100%" max-width="600">
        <console-title>
            <span v-if="isCreate">통합뷰어 생성</span>
            <span v-else>통합뷰어 상세</span>
        </console-title>

        <console-body>
            <v-card>
                <v-card-title class="subtitle-2">기본정보</v-card-title>
                <v-card-text>
                    <v-text-field v-model="integratedViewer.username" label="아이디" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-password-field v-model="integratedViewer.password" label="비밀번호" persistent-placeholder hide-details class="mt-4"></v-password-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="integratedViewer.name" label="담당자(이름)" persistent-placeholder hide-details></v-text-field>
                    <v-text-field v-model="integratedViewer.phone" label="담당자(연락처)" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-text-field v-model="integratedViewer.email" label="담당자(이메일)" persistent-placeholder hide-details class="mt-4"></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="integratedViewer.postcode" label="우편번호" persistent-placeholder hide-details></v-text-field>
                    <v-text-field v-model="integratedViewer.address1" label="기본주소" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-text-field v-model="integratedViewer.address2" label="상세주소" persistent-placeholder hide-details class="mt-4"></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="integratedViewer.ci" label="ci" persistent-placeholder hide-details></v-text-field>
                </v-card-text>
                <v-card-actions />
            </v-card>
        </console-body>

        <v-row class="my-4">
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer />
        </v-row>
    </console-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";

// 통합뷰어 생성·상세. 뷰어 상세(../../viewers/[_id])에서 추천인코드를 뺀 모양이다.
export default {
    components: {
        VPasswordField,
    },
    data() {
        return {
            integratedViewer: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,
            },
        };
    },
    computed: {
        isCreate() {
            return !this.$route.params._id;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this.isCreate) return;

            let { integratedViewer } = await api.console.user.integratedViewers.get({ _id: this.$route.params._id });
            this.integratedViewer = {
                ...this.integratedViewer,
                ...integratedViewer,
            };
        },

        async save() {
            const { post, put } = api.console.user.integratedViewers;

            await (this.isCreate ? post : put)({
                ...this.integratedViewer,
                password: this.integratedViewer.password ? CryptoAES.encrypt(this.integratedViewer.password) : undefined,
            });

            alert("저장되었습니다");
            this.$router.push(`/console/user/integrated-viewers`);
        },
    },
};
</script>
